import { GenericErrorBoundary } from "./GenericErrorBoundary";
import {
  BaseErrorBoundaryProps,
  DocumentViewerContext,
  createDocumentViewerState,
} from "./types";

interface Props extends BaseErrorBoundaryProps, DocumentViewerContext { }

export function FileDocViewerErrorBoundary(props: Props) {
  const { children, onError, ...contextProps } = props;

  return (
    <GenericErrorBoundary
      componentName="FileDocViewer"
      errorBoundaryName="FileDocViewerErrorBoundary"
      componentType="FileDocumentViewer"
      title="Error"
      description="Something went wrong while trying to view your file. Please try reloading the page to continue."
      buttonText="Reload Page"
      onError={onError}
      context={contextProps}
      stateData={createDocumentViewerState(contextProps)}
    >
      {children}
    </GenericErrorBoundary>
  );
}
